import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

import InternationalUpdateContent from '../../../../components/Pages/Internationals/[internationalId]/Update';

export default function InternationalUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Update international page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <InternationalUpdateContent />
    </Layout>
  );
}
